/**
 * Backward-compatible shim — keeps the `AtlasDashboard` import path
 * stable while the actual implementation lives at `./atlas/AtlasTerminal`.
 */
import AtlasTerminal from './atlas/AtlasTerminal';
export default AtlasTerminal;
